import React, { Component } from 'react';
import { Pagination } from 'antd';
import { judgeArr } from '@/shared/functions';
import { RowCol, NoDataContent } from '@/components';
import styled from 'styled-components';
const Root = styled.div `
  .rows_wapper .ant-row:last-child {
    /** row gutter 是数组的时候 margin-bottom 会影响兄弟元素的布局 */
    margin-bottom: 0!important;
  }
`;
class CardList extends Component {
    constructor() {
        super(...arguments);
        this.renderHasData = () => {
            const { pageIndex, pageSize, tableTotal, onChange, children, hasDataClassName, hasDataStyle } = this.props;
            return (<Root className={hasDataClassName} style={hasDataStyle}>
        
        <RowCol gutter={[16, 16]} className="rows_wapper" type="flex" align="stretch">
          {children}
        </RowCol>
        
        <Pagination style={{
                display: 'flex',
                justifyContent: 'center',
                paddingTop: 33,
            }} current={pageIndex} pageSize={pageSize} showQuickJumper={true} total={tableTotal} onChange={onChange} showTotal={total => `共${total}条`}/>
      </Root>);
        };
    }
    render() {
        const { tableData, noDataStyle = {}, noDataClassName } = this.props;
        return judgeArr(tableData) ? this.renderHasData() :
            (<NoDataContent style={Object.assign({ height: 300, backgroundColor: '#fff' }, noDataStyle)} className={noDataClassName}/>);
    }
}
export default CardList;
